import { Component, Input, OnInit } from '@angular/core';
import { AutoDetail } from '../../../../../models/api/view/claim/details/auto/auto-detail';
import { AutoThirdPartyVehicle } from '../../../../../models/api/view/claim/details/auto/auto-third-party-vehicle';
import { BaseComponent } from '../../../../base/base.component';
import { CardComponent } from '../../../../core/panels/card.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';
import { AddressLabelComponent } from '../../../../core/labels/address-label.component';

@Component({
  selector: 'app-third-party-vehicle-au',
  imports: [
    DetailPanelComponent,
    DetailItemComponent,
    CardComponent,
    AddressLabelComponent,
  ],
  template: `
    <div class="tw-flex tw-w-full tw-gap-8">
      <app-card label="3rd party vehicle" class="tw-basis-1/3">
        <app-detail-panel [dataSource]="vehicleData">
          <app-detail-item label="make" name="make" />
          <app-detail-item label="model" name="model" />
          <app-detail-item label="year" name="year" format="d" />
          <app-detail-item label="VIN" name="vin" labelCase="upper" />
          <app-detail-item label="plate" name="plate" />
          <app-detail-item label="state" name="plateState" />
          <app-detail-item
            label="damage description"
            name="damageDescription"
          />
        </app-detail-panel>
      </app-card>
      <app-card label="Driver" class="tw-basis-1/3">
        <app-detail-panel [dataSource]="driverData">
          <app-detail-item label="name" name="driverName" />
          <app-detail-item label="address" name="driverAddress">
            <ng-template #valueTemplate let-value>
              <app-address-label
                [street1]="value"
                [city]="driverData.driverCity"
                [state]="driverData.driverState"
                [postalCode]="driverData.driverZip"
                [country]="driverData.driverCountry"
              />
            </ng-template>
          </app-detail-item>
          <app-detail-item
            label="home phone"
            name="driverPhoneHome"
            format="p"
          />
          <app-detail-item
            label="work phone"
            name="driverPhoneWork"
            format="p"
          />
          <app-detail-item
            label="cell phone"
            name="driverPhoneMobile"
            format="p"
          />
          <app-detail-item label="License number" name="driverLicenseNum" />
          <app-detail-item label="License state" name="driverLicenseState" />
        </app-detail-panel>
      </app-card>
      <div class="tw-basis-1/3 tw-flex tw-flex-col tw-gap-8">
        <app-card label="Owner">
          <app-detail-panel [dataSource]="ownerData">
            <app-detail-item label="name" name="ownerName" />
            <app-detail-item label="address" name="ownerAddress">
              <ng-template #valueTemplate let-value>
                <app-address-label
                  [street1]="value"
                  [city]="ownerData.ownerCity"
                  [state]="ownerData.ownerState"
                  [postalCode]="ownerData.ownerZip"
                  [country]="ownerData.ownerCountry"
                />
              </ng-template>
            </app-detail-item>
            <app-detail-item
              label="cell phone"
              name="ownerPhoneMobile"
              format="p"
            />
            <app-detail-item label="owner type" name="ownerVehicleType" />
          </app-detail-panel>
        </app-card>
        <app-card label="Claim information">
          <app-detail-panel [dataSource]="claimInfoData">
            <app-detail-item
              label="Reported to carrier"
              name="reportedToCarrier"
            />
            <app-detail-item label="Claim number" name="claimNumber" />
            <app-detail-item label="Claim office" name="claimOfficeName" />
            <app-detail-item
              label="Claim office phone"
              name="claimOfficePhone"
              format="p"
            />
          </app-detail-panel>
        </app-card>
      </div>
    </div>
  `,
  styles: ``,
})
export class ThirdPartyVehicleAuComponent extends BaseComponent implements OnInit {
  @Input() autoDetail: AutoDetail;

  get vehicle(): AutoThirdPartyVehicle {
    return this.autoDetail?.thirdPartyVehicle || {};
  }

  get vehicleData(): Partial<AutoThirdPartyVehicle> {
    return this.vehicle;
  }

  get driverData(): Partial<AutoThirdPartyVehicle> {
    return this.vehicle;
  }

  get ownerData(): Partial<AutoThirdPartyVehicle> {
    return this.vehicle;
  }

  ngOnInit(): void {
    this.view.hideLoading();
  }

  get claimInfoData(): Partial<AutoThirdPartyVehicle> {
    return this.vehicle;
  }
}
